import React from 'react';
import WidgetShell from '../../../../../ui/WidgetShell';
import { usePlanner } from '../../../contexts/PlannerContext';
import { SmallText } from '../../../../../ui/Typography.jsx';

export default function ListView() {
  const { tasks = [] } = usePlanner();

  const sorted = [...tasks].sort((a, b) => {
    const aDate = a?.end || a?.dueDate || '';
    const bDate = b?.end || b?.dueDate || '';
    return String(aDate).localeCompare(String(bDate));
  });

  const now = Date.now();

  return (
    <WidgetShell title="List view">
      <div className="space-y-3">
        {sorted.map((task) => (
          <div
            key={task.id}
            className="p-3 rounded-xl border border-[var(--mudo-border)] bg-[var(--mudo-bg-soft)] text-[var(--mudo-text)] flex flex-col gap-2"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="font-medium text-sm sm:text-base">{task.title || "Untitled task"}</div>
              <div className="flex items-center gap-2">
                <StatusChip task={task} now={now} />
              </div>
            </div>
            <SmallText className="text-[var(--mudo-text-muted)]">
              Due: {task.end || task.dueDate || "—"}
            </SmallText>
            {task.status ? (
              <SmallText className="text-[var(--mudo-text-muted)]">Status: {task.status}</SmallText>
            ) : null}
          </div>
        ))}
      </div>
    </WidgetShell>
  );
}

function StatusChip({ task, now }) {
  const endTs = task?.end || task?.dueDate;
  const end = endTs ? new Date(endTs).getTime() : null;
  const overdue = end && end < now && !task.completed;
  const dueSoon = end && end >= now && end - now <= 2 * 24 * 60 * 60 * 1000 && !task.completed;

  let label = "Planned";
  let cls = "bg-[var(--mudo-primary-soft)] text-[var(--mudo-text)]";
  if (overdue) {
    label = "Overdue";
    cls = "bg-red-500/20 text-red-600 border border-red-500/30";
  } else if (dueSoon) {
    label = "Due soon";
    cls = "bg-amber-500/20 text-amber-700 border border-amber-500/30";
  }

  return (
    <span className={`text-[10px] sm:text-xs px-2 py-1 rounded-full border ${cls}`}>
      {label}
    </span>
  );
}
